import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  loadRecentFilters,
  IFilterInfo,
} from 'redux/reducers/usage/filter/filter';

import { RootState } from 'redux/rootReducer';
import { ITopicFilterState } from '../shared';

function useFilters(): ITopicFilterState {
  return useSelector((state: RootState) => {
    if (!state.topicFilters.fulfilled) {
      return {};
    }
    return state.topicFilters.value;
  });
}

function useRecentFilters(): IFilterInfo[] {
  return useSelector((state: RootState) => state.filterUsage.recentFilters);
}

/**
 * This hook returns the current topic filter state and recent filter info from the Redux store
 * @returns see the [[ITopicFilterState]] and [[IFilterInfo]] types for more info
 */
export function useTopicFilters(): [ITopicFilterState, IFilterInfo[]] {
  const dispatch = useDispatch();
  const authProfile = useSelector(
    (state: RootState) => state.authentication.profile
  );

  useEffect(() => {
    if (authProfile) {
      dispatch(loadRecentFilters());
    }
  }, [dispatch, authProfile]);

  const allFilters = useFilters();

  const recentFilters = useRecentFilters();

  return [allFilters, recentFilters];
}
